
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Övrigt</h5>

    <h6 style="font-weight: 500;">Tillämpade lagar</h6>
    <h6>{$selectedItem?.miscellaneous?.applicable_laws ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Bevarandeavvägningar</h6>
    <h6>{$selectedItem?.miscellaneous?.historical_building_considerations ?? "Uppgifter saknas"}</h6>
</div>